import { IUpdateCompanyIdAction } from '../actions/update-company-id';
import { IChannelCareState } from '../state';

export type UpdateCompanyIdAction
    = IUpdateCompanyIdAction;

export const updateCompanyIdReducer =  (state: IChannelCareState, action: UpdateCompanyIdAction) => {
    return ({
        ...state,
        cases: {
            ...state.cases,
            selectedCompanyId: action.companyId
        }
    })
};
